import React, { useEffect, useState } from "react";
import classes from "./Contact.module.css"
import Button from "../../../Button/Button";

const Contact = () => {
    const [queryNameMail, setQueryNameMail] = useState("")
    const [queryLastNameMail, setQueryLastNameMail] = useState("")
    const [queryOrgName, setQueryOrgName] = useState("")
    const [queryTel, setQueryTel] = useState("")
    const [queryMail, setQueryMail] = useState("")
    const [queryTIN, setQueryTIN] = useState("")
    const [queryOGRN, setQueryOGRN] = useState("")
    const [queryMessage, setQueryMessage] = useState("")
    const [data, setData] = useState("")
    const [count, setCount] = useState(0)

    const query = {
        "name": queryNameMail,
        "lastName": queryLastNameMail,
        "OrgName": queryOrgName,
        "tel": queryTel,
        "mail": queryMail,
        "ex": queryTIN + " / " + queryOGRN,
        "message": queryMessage
    }

    

    useEffect(() => {
        if(queryNameMail !== "", queryLastNameMail !== "", queryOrgName !== "", queryTel !== "", queryMail !== "", queryTIN !== "", queryOGRN !== "", queryMessage !== "") {
            try{
                fetch(process.env.REACT_APP_FETCH_URL + "/api/mail", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(query)
                })
                setQueryNameMail("")
                setQueryLastNameMail("")
                setQueryOrgName("")
                setQueryTel("")
                setQueryMail("")
                setQueryTIN("")
                setQueryOGRN("")
                setQueryMessage("")
            } catch(e) {
                console.log(e)
            }
        }
    }, [count])

    return (
        <div className={classes.contact}>
            <div className={classes.contactContent}>
                <h1>Свяжитесь с нами</h1>
                <div className={classes.contactInputs}>
                    <div>
                        <input value={queryNameMail} onChange={(e)=>setQueryNameMail(e.target.value)} type="text" placeholder="Имя"/>
                        <input value={queryLastNameMail} onChange={(e)=>setQueryLastNameMail(e.target.value)} type="text" placeholder="Фамилия"/>
                    </div>
                    <div>
                        <input value={queryOrgName} onChange={(e)=>setQueryOrgName(e.target.value)} type="text" placeholder="Название организации"/>
                    </div>
                    <div>
                        <input value={queryTel} onChange={(e)=>setQueryTel(e.target.value)} type="tel" placeholder="Номер телефона"/>
                    </div>
                    <div>
                        <input value={queryMail} onChange={(e)=>setQueryMail(e.target.value)} type="email" placeholder="Почта"/>
                    </div>
                    <div>
                        <input value={queryTIN} onChange={(e)=>setQueryTIN(e.target.value)} type="number" placeholder="ИНН"/>
                    </div>
                    <div>
                        <input value={queryOGRN} onChange={(e)=>setQueryOGRN(e.target.value)} type="number" placeholder="ОГРН"/>
                    </div>
                    <div>
                        <textarea value={queryMessage} onChange={(e)=>setQueryMessage(e.target.value)} type="text" placeholder="Текст"></textarea>
                    </div>
                    <Button onClick={()=>setCount(count + 1)} title="Отправить" borderRadius="30px"/>
                </div>
            </div>
        </div>
    )
}

export default Contact